import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import JsonDataDe from "./data/data.de.json";
import JsonDataEn from "./data/data.en.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [language, setLanguage] = useState('pl');
  
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() =>{
    if (language === 'pl'){
      setLandingPageData(JsonData);
    }
    else if (language === 'de'){
      setLandingPageData(JsonDataDe);
    }
    else if (language === 'en'){
      setLandingPageData(JsonDataEn);
    }
  }, [language]);

  return (
    <div>
      <Navigation language={setLanguage} data={landingPageData.Navigation}/>
      <Header data={landingPageData.Header} />
      {/* <Features data={landingPageData.Features} /> */}
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery}/>
      <Testimonials data={landingPageData.Testimonials} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
